module.exports = __webpack_public_path__ + "static/img/smell.0f3670ca.png";